import { GLProgram } from '../../program.js';
export class DrawSelectionProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var vertex_source = templates.get('photoshop/GL/shaders/draw/selection/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/draw/selection/fragment.glsl');
        var result = new DrawSelectionProgram(gl, vertex_source, fragment_source);
        result._uniforms['pan'] = gl.getUniformLocation(result._program, 'u_pan');
        result._uniforms['zoom'] = gl.getUniformLocation(result._program, 'u_zoom');
        result._uniforms['model'] = gl.getUniformLocation(result._program, 'u_model');
        return result;
    }

    setUniforms(parameters) {

    }

}